import React, { useState, useRef } from 'react';
import { Placeholder } from "@sitecore-jss/sitecore-jss-react";
import Link from "../../Link";
import DropdownMenu from "modules/dropdownmenu/DropdownMenu";
import ImcDataLayer from "utils/datalayer";
import Logo from "./Logo";

const columnClass = "imc-content--display-flex imc-content--display-flex-column imc-content--display-flex-gap-large imc-section--padded-left-xlarge imc-section--padded-right-xlarge imc-section--padded-left-desktop-none imc-section--padded-right-desktop-none";

interface ColumnProps {
    title: string;
    links: Array<{
        template: {
            name: string;
        };
        link: {
            data: {
                value: any;
            };
        };
        nodeName?: string;
    }>;
    column: {
        title: {
            data: {
                value: string;
            };
        };
        collapse?: {
            data?: {
                value?: boolean;
            };
        };
        link: Array<any>;
    };
    sectionIndex?: number;
    colIndex?: number;
    logo?: any;
    address?: any;
    mapUrl?: any;
    copyright?: any;
    rendering?: any;
}

const Column: React.FC<ColumnProps> = (props) => {

    const isCollapsible = (props.column?.title?.data?.value && props.column?.collapse?.data?.value) ? true : false;
    const [expanded, setExpanded] = useState(!isCollapsible);
    const collapseWrapperRef = useRef<HTMLDivElement>(null);

    const renderColumn = (props: any) => {

        return (
            <div className={(isCollapsible) ? `expand-collapse expand-collapse--mobile ${(expanded) ? 'expand-collapse--expanded' : ''}` : ``}>
                <div>
                    <div className={columnClass}>
                        {(props.column?.title?.data?.value) && <div className={(isCollapsible) ? `imc-breakpoint-display--hide-mobile` : ``} key={`${props.sectionIndex}-${props.colIndex}-title`}>
                            <span className="imc-content--bold">{props.column.title.data.value}</span>
                        </div>}
                        {props.column.link.map((link: any, linkIndex?: number) => {
                            if (link.template.name == "Link") {                            
                                return <div
                                    key={`${props.sectionIndex}-${props.colIndex}-linkIndex`}
                                    className=""
                                >
                                    <div
                                        id={`${props.sectionIndex}-${props.colIndex}-${linkIndex}`}
                                        className="imc-footer-links__item"
                                    >
                                        <Link
                                            onClick={() =>
                                                ImcDataLayer.pushInteractionEvent(
                                                    "navigation",
                                                    "footer",
                                                    link.nodeName
                                                )
                                            }
                                            field={link.link.data}
                                            className="imc-content--gamma imc-link--hover-underline"
                                        />
                                    </div>
                                </div>
                            }
                            else if (link.template.name == "Footer Logo") {
                                return <Logo
                                    logoField={logoField}
                                    addressField={addressField}
                                    mapUrl={mapUrl}
                                    copyright={copyright}
                                />
                            } else if (link.template.name == "Footer Social Icons") {
                                return <div className="">
                                    <Placeholder
                                        name="footer-social-placeholder"
                                        rendering={props.rendering}
                                    />
                                </div>
                            }
                        })}
                    </div>
                </div>
            </div>
        );
    }

    const logoField = props?.logo?.data?.value;
    const addressField = props?.address?.data;
    const mapUrl = props?.mapUrl?.data?.value;
    const copyright = props?.copyright?.data?.value;

    return (
        <div
            key={`${props.sectionIndex}-${props.colIndex}`}
            className={`imc-gallery__item imc-gallery__item--full-width ${(isCollapsible) ? `isCollapsible` : ``}`}
            ref={collapseWrapperRef}
        >
            {(isCollapsible) &&
                <DropdownMenu
                    wrapperClass={`expand-collapse ${(expanded) ? `expand-collapse--expanded` : ``}`}
                    buttonClassName={`imc-breakpoint-display--mobile-only expand-collapse__heading imc-button imc-content--gamma imc-content--bold imc-button--hover-neutral-heaviest imc-content--height-fit-content imc-button--no-border imc-button--transparent imc-section--padded-large imc-section--padded-left-xlarge imc-section--padded-right-xlarge imc-content--full-width imc-content--left`}
                    key={`${props.sectionIndex}-${props.colIndex}-collapse-button`}
                    label={props.column.title.data.value}
                    clickHandler={(event: any, status: boolean) => {
                        setExpanded(status);
                    }}
                    escapeHandler={(event: any, status: boolean) => {
                        setExpanded(status);
                    }}
                    previousFocusOnExit={true}
                    closeOnScroll={false}
                    openState={expanded}
                    chevron={false}
                    wrapperRef={collapseWrapperRef}
                    isCollapsible={isCollapsible}
                >
                    {renderColumn(props)}
                </DropdownMenu>
            }
            {(!isCollapsible) && renderColumn(props)}
        </div>
    );
};

export default Column;